(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["history-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const div = document.getElementById("history-div");
    
    // Check if the device is mobile
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (isMobile) {
        // Apply RTL for mobile regardless of the existing class
        div.classList.remove("ltr");
        div.classList.add("rtl");
    } else {
        // Respect the initial class set by Liquid
        const isLtr = div.classList.contains("ltr");
        if (!isLtr) {
            div.classList.remove("rtl");
            div.classList.add("ltr");
        }
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page"] && !Shopify.designMode) return;
  try {
    
  function getCookie(cName) {
      const name = cName + "=";
      const cDecoded = decodeURIComponent(document.cookie); //to be careful
      const cArr = cDecoded.split('; ');
      let res;
      cArr.forEach(val => {
          if (val.indexOf(name) === 0) res = val.substring(name.length);
      })

      return res;
  }
  const isCookiePresent = getCookie("show_launch_popup");
  if (isCookiePresent) {
      document.querySelector(".shopify-section--launch-popup").classList.add("fade-out");
      document.querySelector(".shopify-section--launch-popup").style.display = "none";
  } else {
      document.querySelector(".shopify-section--launch-popup").classList.remove("fade-out");
      document.querySelector(".shopify-section--launch-popup").style.display = "block";
  }
  let regionSelect = document.querySelector(".js-landing-region-options");
  let languageSelect = document.querySelector(".js-landing-language-options");
  let launchButton = document.querySelector(".js-landing-submit-buuton");
  if (regionSelect) {
      regionSelect.addEventListener("change", _regionOptionChange.bind(this), false);
      launchButton.addEventListener("click", _redirectUrl.bind(this), false);

      function _regionOptionChange(selectValue) {
          let value = selectValue.target.value;
          if (value == "uk") {
              // let langSelect = document.querySelector(".js-landing-language-options");
              // langSelect.style.display ="none"
              // console.log(document.querySelector(".lang_div"))
              // document.querySelector(".lang_div").style.display = "none"
              document.querySelector(".js-landing-language-options").querySelectorAll("option").forEach((option) => {
                  if (option.getAttribute("value") == "french") {
                      option.style.display = "none"
                  }
              });
          } else {
              // document.querySelector(".lang_div").style.display = "block"
              document.querySelector(".js-landing-language-options").querySelectorAll("option").forEach((option) => {
                  if (option.getAttribute("value") == "french") {
                      option.removeAttribute("style");
                  }
              });
          }

      }

      function setCookie(cName, cValue, expDays) {
          let date = new Date();
          date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
          const expires = "expires=" + date.toUTCString();
          document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
      }

      function _redirectUrl(event) {

          const launchTo = event.target.closest(".LaunchPopup__Content-wrapper").querySelector(".js-landing-region-options").value;
          const langTo = event.target.closest(".LaunchPopup__Content-wrapper").querySelector(".js-landing-language-options").value;
          switch (launchTo) {
              case "global":
                  {
                      const div_launch_popup = document.querySelector(".launch-popup-wrapper");
                      div_launch_popup.classList.add("fade-out");
                      div_launch_popup.style.display = "none";

                      setTimeout(() => {
                          div_launch_popup.style.display = "none";
                      }, 800);

                    var body_site = document.body;

                  // Remove the specified class from the body
                  body_site.classList.remove('landingpage_p');
              

                      // setCookie(`show_launch_popup`, `global-${langTo}`,30);
                      setCookie(`show_launch_popup`, `global`, 30);
                      // window.location.href = "https://saphir.com";

                      document.querySelector(".cookie_value").innerText = getCookie("show_launch_popup");
                      //setCookie("show_launch_popup", true);
                      // window.location.href = "https://saphir.com/";
                  }
                  break;
              case "uk":
                  // setTimeout(() => {
                  //     document.querySelector("#landing_launch-popup").classList.remove("custom-launch-popup")
                  //     document.querySelector("#launch-popup").style.display ='none';
                  //   }, 800);
                  document.querySelector(".lang_div").style.display = "none"
                  // setCookie(`show_launch_popup`, `uk-${langTo}`,30);
                  window.location.href = "https://uk.saphir.com/";
                  break;
              default:
                  const launchError = launchWrapper.querySelector(".launch-error");
                  launchError.classList.add("active");
                  launchError.innerText = "Please select a region";
                  break;
          }
          console.log(document.cookie)
      }
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["launch-popup"] && !Shopify.designMode) return;
  try {
    
const countries = window.countryList;
const countries2 = window.countryList2;
const isCookiePresent = getCookie("show_launch_popup");
if (isCookiePresent) {
    console.log(isCookiePresent);
    document.querySelector(".launch-popup-wrapper").remove();
    document.querySelector("body").classList.remove("lock");
    document.querySelector(".shopify-section--launch-popup").style.display = "none";
    document.querySelector(".shopify-section--header").style.visibility = "visible";
} else {
    if (window.themeVariables.settings.pageType == "index") {
        document.querySelector("body").classList.add("lock");
    }
}

function fadeOutAndHidePopup() {
   document.querySelector(".shopify-section--header").style.visibility = "visible";
    const launchPopup = document.querySelector(".launch-popup-wrapper");

    var launchPopup_s = document.querySelector(".launch-popup-wrapper").style;
    launchPopup_s.opacity = 1;
    (function fade() {
        (launchPopup_s.opacity -= .1) < 0 ? launchPopup_s.display = "none" : setTimeout(fade, 40)
    })();
  
    // launchPopup.classList.add("fade-out");
    setCookie("show_launch_popup", "Global");
    setTimeout(() => {
        launchPopup.style.display = "none";
        document.body.classList.remove("lock");
        document.querySelector(".cookie_value").innerText = getCookie("show_launch_popup");
    }, 500);
  document.querySelector(".shopify-section--launch-popup").style.display = "none";
}

const launchButtons = Array.from(document.querySelectorAll(".js-launch-button"));
const mdoRegionSelector = document.querySelector(".main-block__for_mdo .region-selector");
const mdoLanguageSelector = document.querySelector(".main-block__for_mdo .language-selector");
const bdcRegionSelector = document.querySelector(".main-block__for_bdc .region-selector");
const bdcLanguageSelector = document.querySelector(".main-block__for_bdc .language-selector");  

if (launchButtons.length) {
    document.body.classList.add("show_big_popup");
    const handleLaunchClick = (event) => {
        const target = event.currentTarget;
        const launchWrapper = target.closest(".js-launch-wrapper");
        const isStoreOriginBDO = launchWrapper.classList.contains("main-block__for_bdc");

        document.body.classList.remove("show_big_popup");

        if (isStoreOriginBDO) {

            // For BDO Block
            const currentLanguage = window.Shopify.locale;
            console.log({ currentLanguage })
            const regionValue = launchWrapper.querySelector(".launch-selector").value;
            const languageValue = launchWrapper.querySelector(".language-selector").value;
            let redirectionURL = false;
            console.log("For BDO Block", regionValue);

            if (regionValue === 'uk') {
                window.location.href = 'https://uk.saphir.com';
                return;
            }

            if (regionValue && languageValue) {
                if (regionValue === 'global') {
                    const currentLanguage = window.Shopify.locale;
                    if (currentLanguage === languageValue) {
                        fadeOutAndHidePopup();
                        return;
                    } else {
                        setCookie("show_launch_popup", "Global");
                        languageValue === 'en' ? (window.location.href = 'https://saphir.com') : (window.location.href = 'https://saphir.com/fr');
                        return;
                    }
                }
            }

            const launchError = launchWrapper.querySelector(".launch-error");
            launchError.classList.add("active");
            launchError.innerText = "Please select a language and region";
        } else {
            // For MDO Block
            const regionValue = launchWrapper.querySelector(".region-selector").value;
            const languageValue = launchWrapper.querySelector(".language-selector").value;
            console.log({ regionValue, languageValue });
            const selectedOption = launchWrapper.querySelector(".language-selector").selectedOptions[0];
            const site = selectedOption.getAttribute('data-site');
            window.location.href = site;
            
        }
    };

    launchButtons.forEach((launchButton) => launchButton.addEventListener("click", handleLaunchClick));
}
  
if (bdcRegionSelector) { 
const currentRegion = 'global';
  bdcRegionSelector.addEventListener("change", handleChange);
  function handleChange(event) {
        console.log("here bdc");
        const currentRegion = event.target.value;
        console.log("Change trigger bdc!");
        var dropdownWrapper = bdcLanguageSelector.closest(".dropdown_wrapper");
        if(currentRegion === 'uk'){
          bdcLanguageSelector.closest(".dropdown_wrapper").style.display = "none";
        }
      const displayStyle = currentRegion === 'uk' ? "none" : "block";
      
      if (bdcLanguageSelector) {
         if(currentRegion === 'global'){
           bdcLanguageSelector.closest(".dropdown_wrapper").classList.remove('fadeIn2');
           bdcLanguageSelector.closest(".dropdown_wrapper").classList.add('fadeIn');
         }
          bdcLanguageSelector.closest(".dropdown_wrapper").style.display = displayStyle;
      }
       
    }

 // Region
  const regionInput = document.querySelector("#customRegionInput2");
  const regionList = document.querySelector("#customRegionList2");
  const regionButton = document.querySelector("#customRegion2 .custom-button");

  const languageWrapper = document.querySelector("#customLanguage2");
  const languageInput = document.querySelector("#customLanguageInput2");
  const languageList = document.querySelector("#customLanguageList2");
  const languageButton = document.querySelector("#customLanguage2 .custom-button");
  // languageWrapper.style.display = "none";

  const goToSite = document.querySelector("#goToSite2");

  // SVG icon for shop_online
  const getCartIcon = () => `
    <svg width="16" height="16" fill="currentColor" viewBox="0 0 40 40">
      <rect x="15.72" y="10.8" width="8.66" height="2.42"/>
      <path d="M28.55,10.8c-.09-4.61-3.87-8.33-8.49-8.33s-8.4,3.72-8.49,8.33h-6.25v25.32h29.48V10.8h-6.25ZM13.98,19.46v-8.49c0-3.35,2.73-6.08,6.08-6.08s6.08,2.73,6.08,6.08v8.49h2.42v-6.24h3.83v20.48H7.73V13.22h3.83v6.24h2.42Z"/>
    </svg>`;

  // Clear any existing items (if needed)
  regionList.innerHTML = "";

  window.countryList2.forEach(country => {
    const li = document.createElement("li");
    li.setAttribute("data-value", country.name);
    if(country.shop_online)
      li.setAttribute("data-mkt", 1);
    li.innerHTML = country.name + (country.shop_online ? getCartIcon() : "");
    regionList.appendChild(li);

    if(country.code == "gb") {
      let sep = document.createElement("li");
      sep.innerHTML = '---------------------------------------------------------------------------';
      regionList.appendChild(sep);
    }
  });

  // Handle region selection
  regionList.addEventListener("click", (e) => {
    if (e.target.closest("li")) {
      const li = e.target.closest("li");
      const countryName = li.getAttribute("data-value");
      regionInput.value = countryName;
      regionInput.setAttribute("value",countryName);
      if(li.getAttribute("data-mkt")) {
        regionInput.setAttribute("data-mkt",1);
      }
      regionList.classList.remove("open");
      languageList.classList.remove("open");

      // Clear any existing items (if needed)
      languageList.innerHTML = "";
      languageInput.value = '';
      languageInput.setAttribute("value",'');
      
      const country = window.countryList2.find(c => c.name === countryName);
      if (!country) return;
      localStorage.setItem('cntyChoos', country.code);
  
      country.languages.forEach(lang => {

        const li = document.createElement("li");
        li.setAttribute("data-value", lang.name);
        li.setAttribute("data-url", lang.site);
        li.textContent = lang.name;
        languageList.appendChild(li);

        if (countryName == 'United Kingdom' && lang.name == 'English'){
          goToSite.setAttribute("href",li.getAttribute("data-url"));
          goToSite.setAttribute("aria-disabled",false);
        }

      });
      
      //languageWrapper.style.display = "block";
      if (countryName == 'United Kingdom'){
        languageWrapper.style.display = "none";
      }else{
        languageWrapper.style.display = "block";
      }
      const activeError = document.querySelector(".custom-dropdown-error-wrapper .launch-error.active");
      if (activeError) {
        activeError.classList.remove('active');
      }
    }
  });

  // Handle language selection
  languageList.addEventListener("click", (e) => {
    if (e.target.closest("li")) {
      const li = e.target.closest("li");
      const languageName = li.getAttribute("data-value");
      languageInput.value = languageName;
      languageInput.setAttribute("value",languageName);
      regionList.classList.remove("open");
      languageList.classList.remove("open");

      goToSite.setAttribute("href",li.getAttribute("data-url"));
      goToSite.setAttribute("aria-disabled",false);
      const activeError = document.querySelector(".custom-dropdown-error-wrapper .launch-error.active");
      if (activeError) {
        activeError.classList.remove('active');
      }
    }
  });

  regionButton?.addEventListener("click", (e) => {
    e.preventDefault();
    regionList.classList.toggle("open");
    languageList.classList.remove("open");
  });

  languageButton?.addEventListener("click", (e) => {
    e.preventDefault();
    regionList.classList.remove("open");
    languageList.classList.toggle("open");
  });

  document.querySelector('#goToSite2[aria-disabled="true"]').addEventListener("click", (e) => {
    if(goToSite.getAttribute("href") == '#'){
      e.preventDefault();
      const launchError = document.querySelector(".main-block__for_bdc .launch-error");
      launchError.classList.add("active");
      if(regionInput.value == ''){
        launchError.innerText = "Please select a region and language";
      }
      else if(languageInput.value == ''){
        launchError.innerText = "Please select a language";
      }else{
        launchError.innerText = "Please select a language and region";
      }
    }else{
      e.preventDefault();

      if(goToSite.getAttribute("href") !==  'https://uk.saphir.com/') {
        setCookie("show_launch_popup", "Global");
        if(regionInput.getAttribute("data-mkt") == 1) {
          localStorage.setItem('show_ecom', "OK");
        }
      }
      window.location.href = goToSite.getAttribute("href");
    }
  });
}

if (mdoRegionSelector) {
  // Region
  const regionInput = document.querySelector("#customRegionInput");
  const regionList = document.querySelector("#customRegionFtMDOList");
  const regionButton = document.querySelector("#customRegionFtMDO .custom-button");

  const languageWrapper = document.querySelector("#customLanguageFtMDO");
  const languageInput = document.querySelector("#customLanguageInput");
  const languageList = document.querySelector("#customLanguageFtMDOList");
  const languageButton = document.querySelector("#customLanguageFtMDO .custom-button");
  // languageWrapper.style.display = "none";

  const goToSite = document.querySelector("#goToSiteFtMDO");

  // SVG icon for shop_online
  const getCartIcon = () => `
    <svg width="16" height="16" fill="currentColor" viewBox="0 0 40 40">
      <rect x="15.72" y="10.8" width="8.66" height="2.42"/>
      <path d="M28.55,10.8c-.09-4.61-3.87-8.33-8.49-8.33s-8.4,3.72-8.49,8.33h-6.25v25.32h29.48V10.8h-6.25ZM13.98,19.46v-8.49c0-3.35,2.73-6.08,6.08-6.08s6.08,2.73,6.08,6.08v8.49h2.42v-6.24h3.83v20.48H7.73V13.22h3.83v6.24h2.42Z"/>
    </svg>`;

  // Clear any existing items (if needed)
  regionList.innerHTML = "";
  
  window.countryListMDO.forEach(country => {

    const li = document.createElement("li");
    li.setAttribute("data-value", country.name);
    li.innerHTML = country.name + (country.shop_online ? getCartIcon() : "");
    regionList.appendChild(li);

    if(country.code == "gb") {
      let sep = document.createElement("li");
      sep.innerHTML = '---------------------------------------------------------------------------';
      regionList.appendChild(sep);
    }
  });

  // Handle region selection
  regionList.addEventListener("click", (e) => {
    if (e.target.closest("li")) {
      const li = e.target.closest("li");
      const countryName = li.getAttribute("data-value");
      regionInput.value = countryName;
      regionInput.setAttribute("value",countryName);
      regionList.classList.remove("open");
      languageList.classList.remove("open");

      // Clear any existing items (if needed)
      languageList.innerHTML = "";
      languageInput.value = '';
      languageInput.setAttribute("value",'');

      const country = window.countryListMDO.find(c => c.name === countryName);
      if (!country) return;

      country.languages.forEach(lang => {
        const li = document.createElement("li");
        li.setAttribute("data-value", lang.name);
        li.setAttribute("data-url", lang.site+"&c="+country.code+"&l="+lang.code);
        li.textContent = lang.name;
        languageList.appendChild(li);

        if (countryName == 'United Kingdom' && lang.name == 'English'){
          goToSite.setAttribute("href",li.getAttribute("data-url"));
          goToSite.setAttribute("aria-disabled",false);
        }
      });
      
      //languageWrapper.style.display = "block";
      if (countryName == 'United Kingdom'){
        languageWrapper.classList.remove("fadeIn4");
        languageWrapper.classList.add("fadeIn2");
        languageWrapper.style.display = "none";
      }else{
        languageWrapper.classList.remove("fadeIn2");
        languageWrapper.classList.add("fadeIn4");
        languageWrapper.style.display = "block";
      }
      const activeError = document.querySelector(".custom-dropdown-error-wrapper .launch-error.active");
      if (activeError) {
        activeError.classList.remove('active');
      }
    }
  });

  // Handle language selection
  languageList.addEventListener("click", (e) => {
    if (e.target.closest("li")) {
      const li = e.target.closest("li");
      const languageName = li.getAttribute("data-value");
      languageInput.value = languageName;
      languageInput.setAttribute("value",languageName);
      regionList.classList.remove("open");
      languageList.classList.remove("open");
      goToSite.setAttribute("href",li.getAttribute("data-url"));
      console.log(li.getAttribute("data-url"));
      goToSite.setAttribute("aria-disabled",false);
      const activeError = document.querySelector(".custom-dropdown-error-wrapper .launch-error.active");
      if (activeError) {
        activeError.classList.remove('active');
      }
    }
  });

  regionButton?.addEventListener("click", (e) => {
    e.preventDefault();
    regionList.classList.toggle("open");
    languageList.classList.remove("open");
  });

  languageButton?.addEventListener("click", (e) => {
    e.preventDefault();
    regionList.classList.remove("open");
    languageList.classList.toggle("open");
  });

  document.querySelector('#goToSite[aria-disabled="true"]').addEventListener("click", (e) => {
    if(goToSite.getAttribute("href") == '#'){
      e.preventDefault();
      const launchError = document.querySelector(".main-block__for_mdo .launch-error");
      launchError.classList.add("active");
      if(regionInput.value == ''){
        launchError.innerText = "Please select a region and language";
      }
      else if(languageInput.value == ''){
        launchError.innerText = "Please select a language";
      }else{
        launchError.innerText = "Please select a language and region";
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
